const quizData = [
  {
    question: "What is the NALSA judgment about?",
    options: [
      "Rights of transgender persons",
      "Environmental protection",
      "Tax reforms",
      "Education policies",
    ],
    answer: "Rights of transgender persons",
  },
  {
    question: "Which law protects transgender persons in India?",
    options: [
      "Transgender Persons (Protection of Rights) Act, 2019",
      "Right to Education Act",
      "Consumer Protection Act",
      "Mental Healthcare Act",
    ],
    answer: "Transgender Persons (Protection of Rights) Act, 2019",
  },
  {
    question: "When was the Transgender Persons (Protection of Rights) Act passed?",
    options: ["2016", "2018", "2019", "2021"],
    answer: "2019",
  },
  {
    question: "Which article of the Indian Constitution ensures equality before law?",
    options: ["Article 14", "Article 19", "Article 21", "Article 32"],
    answer: "Article 14",
  },
  {
    question: "What does Article 21 guarantee?",
    options: [
      "Right to equality",
      "Right to education",
      "Right to life and personal liberty",
      "Right against exploitation",
    ],
    answer: "Right to life and personal liberty",
  },
  {
    question: "Which landmark judgment recognized transgender persons as the 'third gender'?",
    options: [
      "NALSA vs Union of India (2014)",
      "Kesavananda Bharati vs State of Kerala (1973)",
      "Vishaka vs State of Rajasthan (1997)",
      "Indra Sawhney vs Union of India (1992)",
    ],
    answer: "NALSA vs Union of India (2014)",
  },
  {
    question: "Which government body issues the Transgender Certificate of Identity?",
    options: [
      "District Magistrate",
      "Supreme Court",
      "Ministry of Home Affairs",
      "National Commission for Women",
    ],
    answer: "District Magistrate",
  },
  {
    question: "Which international day is observed on March 31?",
    options: [
      "International Women’s Day",
      "Transgender Day of Visibility",
      "Human Rights Day",
      "World Health Day",
    ],
    answer: "Transgender Day of Visibility",
  },
  {
    question: "What is the punishment for denying a transgender person the right to public places under the 2019 Act?",
    options: [
      "Fine only",
      "Imprisonment from 6 months to 2 years and fine",
      "Warning only",
      "Community service",
    ],
    answer: "Imprisonment from 6 months to 2 years and fine",
  },
  {
    question: "Which commission in India looks into issues of human rights, including those of transgender persons?",
    options: [
      "Election Commission of India",
      "National Human Rights Commission",
      "Planning Commission",
      "Finance Commission",
    ],
    answer: "National Human Rights Commission",
  },
];

export default quizData;
